import { Spine } from 'pixi-spine'
import { Text, Sprite } from 'pixi.js'
import { Tween, Easing } from "@tweenjs/tween.js"
import { Loader } from "pixi.js"
const { resources } = Loader.shared

import Symbol from "./Symbol"
import SymbolScales from "./SymbolScales"

const SCALE = 1.5
export const BADGE_OFFSET = {
    x: 0.35,
    y: -0.05
}

const BADGE_SCALE = 0.75

const WR = "WR"
const WR_FS = "WR_FS"

const TEXT_FORMAT = {
    fontFamily: "WorkSans-Bold",
    fontSize: 48,
    fill: 0xffffff,
    align: "center",
    strokeThickness: 4,
    stroke: 'black',
    miterLimit: 2,
    padding: 10
}

const TWEEN_DURATION = 250

//don't go searching for textures all the time
let badgeTextureCache
function getBadgeTexture() {
    if (badgeTextureCache) {
        return badgeTextureCache
    }

    badgeTextureCache = resources["badge"].texture
    return badgeTextureCache
}

let spineDataCache
function getSpineData() {
    if (spineDataCache) {
        return spineDataCache
    }

    spineDataCache = resources["meteor"].spineData
    return spineDataCache
}

export default class CometSymbol extends Symbol {
    constructor(symbolInfo) {
        super(symbolInfo)
    }

    setup() {
        const { symbolInfo } = this
        const { turnsLeft = 0 } = symbolInfo

        this.key = WR

        const texture = this.getNormalSymbolTexture(WR_FS)
        const sprite = new Sprite(texture)
        this.addChild(sprite)

        const badgeTexture = getBadgeTexture()
        const badge = new Sprite(badgeTexture)
        badge.anchor.set(0.5)
        badge.visible = turnsLeft
        this.addChild(badge)

        const text = new Text(turnsLeft, TEXT_FORMAT)
        text.anchor.set(0.5)
        badge.addChild(text)

        this.sprite = sprite
        this.badge = badge
        this.text = text
    }

    blur() {
        //prevent comets from bursting into flame again when they spin off
        if (!this.hasTurned) {
            this.removeChildren()

            const spineData = getSpineData()
            const spine = new Spine(spineData)
            spine.state.setAnimation(0, "reel", true)

            this.addChild(spine)
            this.addChild(this.badge)
            this.sprite = spine
        }
    }

    unblur() {}

    updateSprite = (size) => {
        const { sprite, badge } = this
        const { width, height } = size

        if (sprite.state) {
            sprite.width = width * SCALE
            sprite.scale.y = sprite.scale.x
        } else {
            super.updateSprite(size)
        }

        const { x, y } = BADGE_OFFSET
        badge.scale.x = sprite.scale.x * BADGE_SCALE
        badge.scale.y = sprite.scale.y * BADGE_SCALE
        badge.position.set(width * x, height * y)
    }

    update(size) {
        const { sprite, text, updateSprite } = this
        updateSprite(size)
        this.size = size
    }

    turnWild() {
        const { key, sprite, badge, currentScale, size } = this

        this.removeChildren()

        const texture = this.getNormalSymbolTexture(WR_FS)
        this.sprite = new Sprite(texture)
        this.addChild(this.sprite)

        const scaleObject = { scale: 0 }
        const tweenUp = new Tween(scaleObject)
            .to({ scale: SymbolScales[key] }, TWEEN_DURATION)
            .easing(Easing.Elastic.Out)
            .onUpdate(() => {
                this.key = WR_FS
                this.currentScale = scaleObject.scale
                this.updateSprite(size)
            })
            .start()

        this.hasTurned = true
    }
}
